import { Navigate, Outlet, useLocation } from "react-router-dom"

const RequiredAuthRoute = () => {

    const location = useLocation()

    // TEMP : Initial storage 
    const token = JSON.parse(localStorage.getItem('token'));

    return (

        token
            ? <Outlet />
            : <Navigate to="/" state={{from:location}} replace/>
    )
}

export default RequiredAuthRoute